import React, { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorToast, SuccessToast } from '../helper/FormHelper';
import LoadingButton from './LoadingButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faLinkedin, faWhatsapp, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faWeixin } from '@fortawesome/free-brands-svg-icons'; // WeChat icon

function EmailForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [need, setNeed] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setloading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!name) return ErrorToast("Name is Required");
  if (!email) return ErrorToast("Email is Required");
  if (!phone) return ErrorToast("Phone Number is Required");
  if (!need) return ErrorToast("Service is Required");
  if (!message) return ErrorToast("Message is Required");

  setloading(true);

  // Show toast immediately
  SuccessToast("Form Submitted Successfully");

  // Clear form immediately
  setName(''); setEmail(''); setPhone(''); setNeed(''); setMessage('');

  // Reset loading immediately
  setloading(false);

  // Send email in background
  fetch('https://jkconsultancy-backend.onrender.com/send-mail', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, phone, need, message }),
  }).then(response => {
    if (!response.ok) throw new Error('Network response was not ok.');
  }).catch(() => {
    // Optional: show error if mail fails
    ErrorToast("Something went wrong sending the email");
  });
};


  return (
    <div style={{
      background: '#F9F8F8',
      padding: '50px 20px',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '900px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        boxShadow: '0px 6px 25px rgba(0,0,0,0.08)',
        borderRadius: '20px',
        overflow: 'hidden',
      }}>
        
        {/* LEFT SIDE FORM */}
        <div style={{
          flex: 1,
          background: '#fff',
          padding: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: isMobile ? 'center' : 'stretch',
          textAlign: isMobile ? 'center' : 'left',
        }}>
          <h2 style={{
            color: '#2E7D32',
            marginBottom: '20px',
            fontSize: '24px',
            border: '2px solid #2E7D32',
            borderRadius: '50px',
            padding: '10px 15px',
            textAlign: 'center',
            display: 'inline-block'
          }}>
            Get a Free Consultation
          </h2>
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <div style={{ marginBottom: '12px' }}>
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1.5px solid #2E7D32' }}
              />
            </div>
            <div style={{ marginBottom: '12px' }}>
              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1.5px solid #2E7D32' }}
              />
            </div>
            <div style={{ marginBottom: '12px' }}>
              <input
                type="text"
                placeholder="Your Phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1.5px solid #2E7D32' }}
              />
            </div>
            <div style={{ marginBottom: '12px' }}>
              <select
                value={need}
                onChange={(e) => setNeed(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1.5px solid #2E7D32' }}
              >
                <option value="" disabled>Select Your Service</option>
                <option>Startup Basic</option>
                <option>Startup Exclusive</option>
                <option>Startup Premium</option>
                <option>Company Formation</option>
                <option>Society Registration</option>
                <option>Partnership Registration</option>
                <option>RJSC Return Fillig</option>
                <option>Loan Consultancy</option>
                <option>Import License (IRC)</option>
                <option>Export License (ERC)</option>
                <option>BSTI Registration</option>
                <option>Trade License</option>
                <option>Individual TAX</option>
                <option>Corporate TAX</option>
                <option>Value Added TAX (VAT)</option>
                <option>TIN Registration</option>
                <option>BIN Registration</option>
                <option>Trademark</option>
                <option>Copyright</option>
                <option>Patent</option>
                <option>Industrail Design</option>
                <option>IPR Enforcement</option>
                <option>BTCL Domain Registration</option>
                <option>Foreign Company Foramation</option>
                <option>Foreign Direct Investment</option>
                <option>BIDA Permission</option>
                <option>Work Permit VISA</option>
                <option>Foreign Delegates</option>
                <option>Account Service</option>
                <option>Book Keeping Services</option>
                <option>Small Business</option>
              </select>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <textarea
                placeholder="Your Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{ width: '100%', height: '110px', padding: '12px', borderRadius: '8px', border: '1.5px solid #2E7D32' }}
              />
            </div>

            {loading ? (
              <button disabled style={{
                width: '100%', padding: '12px', background: '#0A4FA3', color: '#fff',
                borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
              }}>
                Loading <LoadingButton style={{ width: '18px', height: '18px' }} />
              </button>
            ) : (
              <button type="submit" style={{
                width: '100%', padding: '12px', background: '#2E7D32', color: '#fff',
                border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '15px', fontWeight: '600'
              }}>
                Submit
              </button>
            )}
          </form>
        </div>

        {/* RIGHT SIDE INFO */}
        <div style={{
          flex: 1,
          background: '#0A4FA3',
          color: 'white',
          padding: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: isMobile ? 'center' : 'flex-start',
          textAlign: isMobile ? 'center' : 'left',
          marginTop: isMobile ? '20px' : '0'
        }}>
          <h2 style={{ marginBottom: '18px', color: '#FFFF', textAlign: isMobile ? 'center' : 'left' }}>Contact Information</h2>
          <p style={{ marginBottom: '12px' }}>
            <strong>📍 Address:</strong><br />
            752/2, Begum Rokeya Ave, Shewrapara, Dhaka 1216, Bangladesh
          </p>
          <p style={{ marginBottom: '12px' }}>
            <strong>📞 Phone:</strong><br />
            +8801511-404971 <br />
            +8801601-404971 <br />
            +8802226622966
          </p>
          <p style={{ marginBottom: '12px' }}>
            <strong>✉️ Email:</strong><br />
            info@jkassociates.com.bd
          </p>
          <p style={{ marginBottom: '12px' }}>
            <strong>💬 WeChat:</strong><br />
            WeChat ID: jkassociates <FontAwesomeIcon icon={faWeixin} style={{ marginLeft: '8px' }} />
          </p>

          <div style={{ marginTop: '20px', display: 'flex', gap: '20px', fontSize: '24px', justifyContent: isMobile ? 'center' : 'flex-start' }}>
            <a href="https://jkassociates.com.bd" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFF' }}>
              <FontAwesomeIcon icon={faGlobe} />
            </a>
            <a href="https://wa.me/01511404971" target="_blank" rel="noopener noreferrer" style={{ color: '#25D366' }}>
              <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            <a href="https://twitter.com/jkassociates" target="_blank" rel="noopener noreferrer" style={{ color: '#1DA1F2' }}>
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://facebook.com/jkassociates" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFF' }}>
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://linkedin.com/jkassociates" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFF' }}>
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href="https://youtube.com/jkassociates" target="_blank" rel="noopener noreferrer" style={{ color: '#FF0000' }}>
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailForm;
